import { t } from "ttag";

import type { ModalProps } from "@/shared/models/legacy-types";
import { Card, DeliveryIcon, Dialog, DocumentAddIcon } from "@/shared/ui";

export const MedicationRefillModal = ({ show, onClose }: ModalProps) => {
  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={DocumentAddIcon}>
          <Dialog.Title>{t`Medication refills`}</Dialog.Title>
          <Dialog.Description>{t`Your provider will review your responses and prescribe as appropriate. Simply fill out the following intake without the need to schedule an appointment! We will reach out if we have any questions.`}</Dialog.Description>
        </Dialog.Header>

        <Card.Root>
          <Card.Content className="flex items-center gap-2.5">
            <DeliveryIcon className="size-4 shrink-0" />
            <Card.Description className="font-medium">{t`Your refill will be approved between 2-3 business days after completing this form.`}</Card.Description>
          </Card.Content>
        </Card.Root>
      </Dialog.Content>
    </Dialog.Root>
  );
};
